import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeadershipThemeTopThreadsLoadAction } from '../../domains/leadershipThemeTopThreads/actions.types';

import { LeadershipThemeTopThreadsLifecycle } from './types';

const initialState: LeadershipThemeTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<LeadershipThemeTopThreadsLifecycle, LeadershipThemeTopThreadsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_THEME_TOP_THREADS.LOAD_PENDING':
      return setPending();
    case 'LEADERSHIP_THEME_TOP_THREADS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.leadershipThemeTopThreads);
    case 'LEADERSHIP_THEME_TOP_THREADS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
